import React from 'react';
import styled from 'styled-components';

const EventsList = styled.div`
  background-color: ${props => props.theme.colors.filter_bg};
  padding-left: 16px;
  width: 100%;
`;

export default EventsList;
